import * as Edge from '../core';

const getRouteName = (exerciseTypeId: Edge.Models.ExerciseTypeId) =>
	Object.keys(Edge.Models.ExerciseTypeId)[
		Object.values(Edge.Models.ExerciseTypeId).indexOf(exerciseTypeId)
	].toLowerCase();

export abstract class ExerciseService {
	public static async createExerciseResult(
		command: Edge.Models.CreateExerciseResultCommand
	): Promise<Edge.Models.CreateExerciseResultCommand> {
		const route = Edge.API.ServerRoute.forAction('exercises', `results/${getRouteName(command.exerciseTypeId)}`);
		return await Edge.API.post(route, command);
	}

	public static async completeExercise(
		command: Edge.Models.CompleteExerciseCommand
	): Promise<Edge.Models.ActiveSessionResponse> {
		const route = Edge.API.ServerRoute.forAction('exercises', `results/complete`);
		const [data, responseDateUtc] = await Edge.API.patchWithResponseDate<Edge.Models.BaseSessionResponse>(
			route,
			command
		);
		return {
			active: data,
			responseDateUtc,
			receivedDateUtc: new Date(),
		} as Edge.Models.ActiveSessionResponse;
	}

	public static async completeGuardVisionScreening(
		command: Edge.Models.CompleteGuardVisionScreeningCommand
	): Promise<void> {
		const route = Edge.API.ServerRoute.forAction('exercises', `results/guardVision`);
		await Edge.API.post(route, command);
	}
}
